angular.module('impactx.controlstructure').controller('CTRLDCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    CTRLDCtrl
]);

function CTRLDCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/ctrld/view";
    $scope.endPointSave = "/control/ctrld/save";
    $scope.endPointDelete = "/control/ctrld/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.ctrld.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.ctrld.readOnly && !$scope.data.ctrld.deprecated;
    }
}